import React from 'react';
import { movdTokens } from '../design-system/movdTokens.js';

const pricing = [
  { title: 'Local Move', price: '$129/hr', details: ['2 professional movers & 1 truck', 'Includes basic insurance', 'Free moving blankets & dollies', 'No hidden fees', 'Minimum 2 hours'] },
  { title: 'Long Distance', price: 'Custom', details: ['Flat-rate or per km pricing', 'Dedicated move coordinator', 'GPS-tracked trucks', 'Flexible scheduling', 'All provinces served'] },
  { title: 'Packing Services', price: '$59/hr', details: ['Professional packers', 'All supplies included', 'Fragile & specialty item care', 'Unpacking available'] },
  { title: 'Storage', price: '$49/wk', details: ['Secure, climate-controlled', 'Short & long-term options', '24/7 access available', 'Easy move-in/move-out'] },
];

export default function Pricing() {
  return (
    <main style={{ padding: 32 }}>
      <h1 style={{ margin: '0 0 8px', fontSize: 32, fontWeight: 900 }}>Transparent pricing</h1>
      <p style={{ marginBottom: 32, fontSize: 16 }}>Simple, honest pricing for every move. All prices include fuel, mileage within city limits, and basic insurance. Taxes extra.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 24 }}>
        {pricing.map(plan => (
          <div key={plan.title} style={{ padding: 24, borderRadius: 12, boxShadow: movdTokens.shadow.panel, background: '#fff', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>{plan.title}</h2>
            <p style={{ margin: 0, fontSize: 28, fontWeight: 900, color: movdTokens.color.action.primary }}>{plan.price}</p>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {plan.details.map(detail => <li key={detail} style={{ fontSize: 14, marginBottom: 4 }}>{detail}</li>)}
            </ul>
          </div>
        ))}
      </div>
      <p style={{ marginTop: 32, textAlign: 'center', fontSize: 14 }}>
        For a precise quote, use our online tool or contact us for a custom estimate. <a href="/faq" style={{ color: movdTokens.color.action.primary, fontWeight: 700 }}>See pricing FAQ</a>
      </p>
    </main>
  );
}
